/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_SavedInputs */

const en_admin_indexnow_saved = /** @type {(inputs: Admin_Indexnow_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key saved`)
};

/**
* | output |
* | --- |
* | "Key saved" |
*
* @param {Admin_Indexnow_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_saved = /** @type {((inputs?: Admin_Indexnow_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_saved(inputs)
});
export { admin_indexnow_saved as "admin.indexnow.saved" }